import { forEach } from '../functions';

const mobileMenuSubMenuExpandedClass = 'gmp-sub-menu-mobile--expanded';
const subMenuExpandedClass = 'gmp-sub-menu-item--expanded';

export default function menu(){
  var nav = document.getElementById('site-navigation');
  var menuItems = nav.querySelectorAll('.menu-item-has-children');
  var subMenus = document.querySelectorAll('.sub-menu');
  var menuClose = document.getElementById('close-mobile');
  jQuery(subMenus).append('<button class="gmp-sub-menu-mobile-back"></button>');
  forEach(menuItems, function(index, item) {
    var backButton = item.querySelector('.gmp-sub-menu-mobile-back');
    var link = item.querySelector('a');

    link.addEventListener('click', function(event) {
      event.preventDefault();
      forEach(menuItems, function(index, m){
        if(m !== item)
          m.classList.remove(subMenuExpandedClass)
      })
      nav.classList.add(mobileMenuSubMenuExpandedClass);
      item.classList.add(subMenuExpandedClass);
    });
    if(backButton) backButton.addEventListener('click', (event) => closeSubMenu(menuItems, nav, event));
  });
  menuClose.addEventListener('click', (event) => closeSubMenu(menuItems, nav, event));
}

function closeSubMenu(menuItems, nav, event){
  forEach(menuItems, function(index, m) {
    m.classList.remove(subMenuExpandedClass)
  })
  nav.classList.remove(mobileMenuSubMenuExpandedClass)
}
